module.exports = __webpack_public_path__ + "img/tksImage.688ce8dd.png";